// This component will be stateless

const Footer = () => {
    return (
        <footer>
                
                <div className="footer">
                    <div className="scroll">
                        <a href="#scrollUp" className="scrollLink">Back to top</a>
                    </div>
                    <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 216.4 204" width="10px" height="10px"><polygon points="176.7 202.6 109.6 168.6 43.3 204 54.8 130.6 0 78.9 75 67.3 107.5 0 141.4 66.6 216.4 76.2 163 129.2 176.7 202.6" fill="#ffa96e" /></svg>   
                    <a href="https://rittu-berman.com/">App Built & Designed by Rittu Berman at Juno College </a>
                    <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 216.4 204" width="10px" height="10px"><polygon points="176.7 202.6 109.6 168.6 43.3 204 54.8 130.6 0 78.9 75 67.3 107.5 0 141.4 66.6 216.4 76.2 163 129.2 176.7 202.6" fill="#ffa96e" /></svg>   
                </div>   
        </footer>
    )
};

export default Footer;